/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { vappContainer } from '@/application';
import { BreadcrumbService } from '@/services/breadcrumbService';
import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { toHeaderCase } from 'js-convert-case';
import { editProfile } from '../../config/editProfile.config';
import { error } from '../../config/error.config';
import { header } from '../../config/header.config';
import { loading } from '../../config/loading.config';
import { notifications } from '../../config/notifications.config';
export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args?: any): any;
}

const getBreadcrumbService = () => {
  return vappContainer.get<BreadcrumbService>(BreadcrumbService.displayName);
};
export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  getProps(args?: any) {
    return {
      header: { ...header, ...{} },
      loading: loading,
      error: error,
      notifications: notifications,
    };
  }
}
